<template>
  <div>
    <record-info
      class="mb-100"
      :record="record"
      :status="status"
      is-large
    ></record-info>

    <record-status-selector
      class="mb-100"
      :record="record"
    ></record-status-selector>

    <record-property-detail-summary
      class="mb-100"
      :property="record.property"
    ></record-property-detail-summary>

    <p class="mb-200">Motivation: {{ motivationLabel }}</p>

    <div class="mb-200">
      <p class="stat--label">Maximum Allowed Offer</p>
      <p class="stat--amount">{{ maxAllowableOffer }}</p>
    </div>

    <div class="mb-200">
      <p class="stat--label">Latest Buying Offer</p>

      <template v-if="latestOffer">
        <p class="stat--amount">{{ latestOffer.amount }}</p>
        <p class="stat--subtitle">Made via {{ latestOffer.type }} by {{ latestOffer.madeBy }} on {{ latestOffer.date }}</p>
      </template>
      <p v-else class="empty_message">No offer has been made</p>
    </div>

    <notes-with-latest :record="record"></notes-with-latest>
  </div>
</template>

<script>
import {ENUMS} from "../../../services/enums";
import dates from "../../../services/dates";

export default {
  name: "LeadBoxActive",
  props: {
    record: {
      type: Object,
      required: true
    },
    status: {
      type: Object,
      required: true
    }
  },
  computed: {
    motivationLabel() {
      return this.$utils.newGetEnumLabel(this.record.motivation, ENUMS.MotivationEnum)
    },
    maxAllowableOffer() {
      const maxAllowableOffer = (this.record.analysis)
        ? this.record.analysis.maximum_allowable_offer
        : this.record.maximum_allowable_offer;

      if (maxAllowableOffer) {
        return this.$utils.formatCurrency(maxAllowableOffer);
      } else {
        return "--";
      }
    },
    latestOffer() {
      if (!this.record.latest_offer) return null;

      const user = this.$store.getters.users.find(u => u.id === this.record.latest_offer.made_by);

      return {
        amount: this.$utils.formatCurrency(this.record.latest_offer.amount),
        type: this.$utils.newGetEnumLabel(this.record.latest_offer.type, ENUMS.BuyingOfferTypeEnum).toLowerCase(),
        madeBy: user ? user.full_name : "Seller",
        date: dates.formatAsDate(this.record.latest_offer.date),
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.stat {

  &--label {
    font-size: 0.75rem;
    color: $text-muted;
  }

  &--amount {
    margin-top: 4px;
    font-size: 1.125rem;
  }

  &--subtitle {
    margin-top: 4px;
    font-size: 0.625rem;
    color: $text-muted;
  }
}

.empty_message {
  margin-top: 12px;
  font-style: italic;
}
</style>
